module.exports = __webpack_public_path__ + "/build/web/images/hero-stalenservice@3x.ba7944115df6dea6b12059913096bc8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-stalenservice@3x.jpg
// module id = 147
// module chunks = 13